// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #5be1e6;
  --accent: #DF0051;
  --shade0: #171717;
  --shade1: #1a1a1a;
  --shade2: #222222;
  --shade3: #2C2C2E;
  --shade4: #646464;
  --shade5: #9f9f9f;
  --shade6: #DFDEDF;
  --shade7: #F2F3F3;
  --shade8: #F6F7F6;
  --black: #000000;
  --white: #ffffff;
  --red: #F44336;
  --orange: #EF9125;
  --green: #22c55e;
  --blue: #06b6d4;
}

html[data-theme=light] {
  --shade0: #f0f0f0;
  --shade1: #e7e7e7;
  --shade2: #FEFFFE;
  --shade3: #F0F3F4;
  --shade4: #2c2c2c;
  --shade5: #131313;
  --shade6: #000000;
}

.black {
  background-color: var(--black);
}

.white {
  background-color: var(--white);
}

.red {
  background-color: var(--red);
}

.orange {
  background-color: var(--orange);
}

.blue {
  background-color: var(--blue);
}

.green {
  background-color: var(--green);
}

.red {
  background-color: var(--red);
}

.primary {
  background-color: var(--primary);
}

.primary-dark {
  background-color: #20ced4;
}

.primary50 {
  background-color: rgba(91, 225, 230, 0.5);
}

.accent {
  background-color: var(--accent);
}

.teal {
  background-color: #5BE1E6;
}

.accent--text {
  color: var(--accent);
}

.primary--text {
  color: var(--primary);
}

.black--text {
  color: var(--black);
}

.teal--text {
  color: #5BE1E6;
}

.white--text {
  color: var(--white);
}

.red--text {
  color: var(--red);
}

.green--text {
  color: var(--green);
}

.red--text {
  color: var(--red);
}

.blue--text {
  color: var(--blue);
}

.shade0 {
  background-color: var(--shade0);
}

.shade1 {
  background-color: var(--shade1);
}

.shade2 {
  background-color: var(--shade2);
}

.shade3 {
  background-color: var(--shade3);
}

.shade4 {
  background-color: var(--shade4);
}

.shade5 {
  background-color: var(--shade5);
}

.shade6 {
  background-color: var(--shade6);
}

.shade7 {
  background-color: var(--shade7);
}

.shade8 {
  background-color: var(--shade8);
}

.shade0--text {
  color: var(--shade0);
}

.shade1--text {
  color: var(--shade1);
}

.shade2--text {
  color: var(--shade2);
}

.shade3--text {
  color: var(--shade3);
}

.shade4--text {
  color: var(--shade4);
}

.shade5--text {
  color: var(--shade5);
}

.shade6--text {
  color: var(--shade6);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/color.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AADJ;;AAIA;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AADJ;;AAMA;EACI,8BAAA;AAHJ;;AAMA;EACI,8BAAA;AAHJ;;AAMA;EACI,4BAAA;AAHJ;;AAMA;EACI,+BAAA;AAHJ;;AAMA;EACI,6BAAA;AAHJ;;AAMA;EACI,8BAAA;AAHJ;;AAMA;EACI,4BAAA;AAHJ;;AAMA;EACI,gCAAA;AAHJ;;AAMA;EACI,yBAnCW;AAgCf;;AAMA;EACI,yCAAA;AAHJ;;AAMA;EACI,+BAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,oBAAA;AAHJ;;AAMA;EACI,qBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,+BAAA;AAHJ;;AAKA;EACI,+BAAA;AAFJ;;AAIA;EACI,+BAAA;AADJ;;AAGA;EACI,+BAAA;AAAJ;;AAEA;EACI,+BAAA;AACJ;;AACA;EACI,+BAAA;AAEJ;;AAAA;EACI,+BAAA;AAGJ;;AADA;EACI,+BAAA;AAIJ;;AAFA;EACI,+BAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ","sourcesContent":["$primary-color: #5be1e6;\n\n:root {\n    --primary: #5be1e6;\n    --accent: #DF0051;\n    --shade0: #171717;\n    --shade1: #1a1a1a;\n    --shade2: #222222;\n    --shade3: #2C2C2E;\n    --shade4: #646464;\n    --shade5: #9f9f9f;\n    --shade6: #DFDEDF;\n    --shade7: #F2F3F3;\n    --shade8: #F6F7F6;\n    --black: #000000;\n    --white: #ffffff;\n    --red: #F44336;\n    --orange: #EF9125;\n    --green: #22c55e;\n    --blue: #06b6d4;\n}\n\nhtml[data-theme='light'] {\n    --shade0: #f0f0f0;\n    --shade1: #e7e7e7;\n    --shade2: #FEFFFE;\n    --shade3: #F0F3F4;\n    --shade4: #2c2c2c;\n    --shade5: #131313;\n    --shade6: #000000;\n}\n\n$dark-primary: darken($primary-color, 15%);\n\n.black {\n    background-color: var(--black);\n}\n\n.white {\n    background-color: var(--white);\n}\n\n.red {\n    background-color: var(--red);\n}\n\n.orange {\n    background-color: var(--orange);\n}\n\n.blue {\n    background-color: var(--blue);\n}\n\n.green {\n    background-color: var(--green);\n}\n\n.red {\n    background-color: var(--red);\n}\n\n.primary {\n    background-color:  var(--primary);\n}\n\n.primary-dark {\n    background-color: $dark-primary;\n}\n\n.primary50 {\n    background-color:  rgb(91 225 230 / 50%);\n}\n\n.accent {\n    background-color: var(--accent);\n}\n\n.teal {\n    background-color: #5BE1E6;\n}\n\n.accent--text {\n    color: var(--accent);\n}\n\n.primary--text {\n    color: var(--primary);\n}\n\n.black--text {\n    color: var(--black);\n}\n\n.teal--text {\n    color: #5BE1E6;\n}\n\n.white--text {\n    color: var(--white);\n}\n\n.red--text {\n    color: var(--red);\n}\n\n.green--text {\n    color: var(--green);\n}\n\n.red--text {\n    color: var(--red);\n}\n\n.blue--text {\n    color: var(--blue);\n}\n\n.shade0 {\n    background-color: var(--shade0);\n}\n.shade1 {\n    background-color: var(--shade1);\n}\n.shade2 {\n    background-color: var(--shade2);\n}\n.shade3 {\n    background-color: var(--shade3);\n}\n.shade4 {\n    background-color: var(--shade4);\n}\n.shade5 {\n    background-color: var(--shade5);\n}\n.shade6 {\n    background-color: var(--shade6);\n}\n.shade7 {\n    background-color: var(--shade7);\n}\n.shade8 {\n    background-color: var(--shade8);\n}\n\n.shade0--text {\n    color: var(--shade0);\n}\n\n.shade1--text {\n    color: var(--shade1);\n}\n\n.shade2--text {\n    color: var(--shade2);\n}\n\n.shade3--text {\n    color: var(--shade3);\n}\n\n.shade4--text {\n    color: var(--shade4);\n}\n\n.shade5--text {\n    color: var(--shade5);\n}\n\n.shade6--text {\n    color: var(--shade6);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
